import { merge } from 'lodash-es';
import { resolvePersonalizationRule } from '@utils/personalization-cookie-match';

export default {
    handlesPersonalizationCookie: true,

    props: {
        personalization: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            isMounted: false,
        };
    },

    computed: {
        activePersonalization() {
            const currentForm = merge({}, this.presetForm, this.l10n?.form || {});

            if (!Number.isInteger(this.step) || !currentForm) return this.personalization;

            const stepPersonalization = currentForm.registration?.steps?.[this.step]?.personalization;
            return stepPersonalization || this.personalization;
        },

        personalizationItem() {
            if (!this.isMounted) return {};

            return resolvePersonalizationRule(this.activePersonalization, {
                query: this.$route.query,
                referrer: document.referrer,
            })?.item || {};
        },

        personalizationData() {
            const item = this.personalizationItem;
            const data = item.data || {};
            const setQuery = item.setQuery;
            if (!setQuery) return data;

            const [key, value] = Object.entries(setQuery)[0];
            return merge({}, data, { form: { flow: { personalizationLocalStorage: `${key}-${value}` } } });
        },

        sliceContent() {
            return merge({}, this.$props, this.personalizationData);
        },
    },

    methods: {
        setQuery() {
            if (!this.personalizationItem.setQuery) return;
            this.$router.replace({
                path: this.$route.path,
                query: { ...this.$route.query, ...this.personalizationItem.setQuery },
            });
        },
    },

    mounted() {
        this.isMounted = true;
        this.setQuery();
    },
};
